import {
	DataQuery,
	DBxEvent,
    ParserUtil,
    FontLibrary,
    DomUtil
} from "cartovista";
import { get, show } from "../appTools/Alerts";
import {exportToPDF} from "../appTools/Print";
import {drawStyleIconCanvas} from "../utils/CvUtils";
import TransferTool from "./TransferTool";
import "../../css/DecoupagePanel.css";
import { Popover, Modal } from 'bootstrap';


   
    
    class Statistics {
        constructor(){
            Object.defineProperties(this, {
                "sumTotal": {
                    get(){ 
                        var sum,
                            dataTable = window.cartovista.getMap(C.MAP.ID).getLayer(C.PANELS.DECOUPAGE_PANEL.POINTS.LAYER_ID).getDataTable(C.PANELS.DECOUPAGE_PANEL.POINTS.DATATABLE_ID);
                        new DataQuery(dataTable.getDataColumns([C.PANELS.DECOUPAGE_PANEL.POINTS.SUM_DATACOLUMN_ID]), null, ["SUM"])
                            .execute(function(result) {
                                sum = result.statisticsValues[dataTable.id][C.PANELS.DECOUPAGE_PANEL.POINTS.SUM_DATACOLUMN_ID].SUM;
                            });
                        return sum;
                    },
                },
                "sectorsCount": {
                    get(){ return window.sectorsDataStore.getSectorsData(window.cartovista.getMap(C.MAP.ID)._scenarioId).length; },
                },
                "nbr_mean": {
                    get(){ return _.round(this.sumTotal / this.sectorsCount); },
                },
                "nbr_min": {
                    get(){ return _.floor(this.nbr_mean - (this.nbr_mean * 0.25)); },
                },
                "nbr_max": {
                    get(){ return _.ceil(this.nbr_mean + (this.nbr_mean * 0.25)); },
                },
            });
        }
    }

    export default class DecoupagePanel {
        constructor(){
             this.sectorsTableHtml = '<table class="table table-sm table-hover">' +
                                '<thead>' +
                                    '<tr>' +
                                        '<th colspan="1"></th>' +
                                        '<th colspan="1" class="text-center">Couleur</th>' +
                                        '<th colspan="1" class="text-center">Code ' + C.LOCALES.SECTORS.SECTOR.NAMES.SHORT_SINGLE + '</th>' +
                                        '<th colspan="1" class="text-center">Nbr ' + C.LOCALES.POINTS.NAMES.SHORT_PLURAL +'</th>' +
                                        (C.PANELS.DECOUPAGE_PANEL.INCLUDE_STATISTICS ? '<th colspan="1" class="text-center">%</th>' : '') +
                                        '<th colspan="1" class="text-center">Desc</th>' +
                                    '</tr>' +
                                '</thead>' +
                                '<tbody id="DecoupagePanel_sectorsTableBody" class="table-group-divider"></tbody>' +
                            '</table>';
        window.cartovista.addOneTimeEventListener(window.cartovista.EVENTS.MAP_LOADED + "_" + C.MAP.ID, this._onCartoVistaMapLoaded, this);
        window.cartovista.addOneTimeEventListener(C.PANELS.DECOUPAGE_PANEL.POINTS.LAYER_ID + "_layerCreated", this._onPointsLayerCreated, this);
        window.cartovista.addEventListener("AuthSession_UserLoggedIn", this._onAuthSessionUserLoggedIn, this);
        window.cartovista.addEventListener("ReloadDataTool_ReloadStarted", this._onReloadDataStarted, this);
        window.cartovista.addEventListener("ReloadDataTool_ReloadCompleted", this._onReloadDataCompleted, this);
        window.cartovista.addOneTimeEventListener("ServerDataInitialized", this._onServerDataInitialized, this);
        this._$panelsContainer = $('<div id="DecoupagePanel_container">' +
                                (!DomUtil.isIE() ? '<button class="DecoupagePanel_printBtn easeOut cv-button k-button k-button-icon" data-role="button" role="button" aria-disabled="false" tabindex="-1" title="Exporter le graphique en PDF">' +
                                    '<span class="k-sprite cv-icon cv-icon-export"></span>' +
                                '</button>' : "") +
                                (C.PANELS.DECOUPAGE_PANEL.INCLUDE_STATISTICS ? '<div class="card" style="margin-bottom:10px">' + 
                                    '<div class="card-header">' + 
                                        '<h5>' +
                                            '<strong><a role="button" data-bs-toggle="collapse" href="#DecoupagePanel_statsPanel" aria-expanded="true" aria-controls="DecoupagePanel_statsPanel">Statistiques</a></strong>' +
                                        '</h5>' +
                                    '</div>' + 
                                    '<div class="collapse show" id="DecoupagePanel_statsPanel">' +
                                        '<div class="card-body">' + 
                                            '<table class="table" style="margin:0;">' +
                                                '<tr>' +
                                                    '<th colspan="2">Nombre total d\'' + C.LOCALES.POINTS.NAMES.LONG_PLURAL + '</th>' +
                                                    '<td id="DecoupagePanel_statsPanel_nbrTotal" colspan="1"></td>' +
                                                '</tr>' +
                                                '<tr>' +
                                                    '<th colspan="2">Nombre de ' + C.LOCALES.SECTORS.SECTOR.NAMES.SHORT_PLURAL + '</th>' +
                                                    '<td id="DecoupagePanel_statsPanel_sectorsCount" colspan="1"></td>' +
                                                '</tr>' +
                                                '<tr>' +
                                                    '<th colspan="2">Nombre moyen d\'' + C.LOCALES.POINTS.NAMES.LONG_PLURAL + '</th>' +
                                                    '<td id="DecoupagePanel_statsPanel_nbrMean" colspan="1"></td>' +
                                                '</tr>' +
                                                '<tr>' +
                                                    '<th colspan="2">Nombre minimum d\'' + C.LOCALES.POINTS.NAMES.LONG_PLURAL + '</th>' +
                                                    '<td id="DecoupagePanel_statsPanel_nbrMin" colspan="1"></td>' +
                                                '</tr>' +
                                                '<tr>' +
                                                    '<th colspan="2">Nombre maximum d\'' + C.LOCALES.POINTS.NAMES.LONG_PLURAL + '</th>' +
                                                    '<td id="DecoupagePanel_statsPanel_nbrMax" colspan="1"></td>' +
                                                '</tr>' +
                                            '</table>' +
                                        '</div>' + 
                                    '</div>' + 
                                '</div>' : "") +
                                '<div class="card DecoupagePanel_printable">' + 
                                    '<div class="card-header">' + 
                                        '<h5>' +
                                            '<strong>' + _.capitalize(C.LOCALES.SECTORS.SECTOR.NAMES.LONG_PLURAL) + '</strong>' +
                                            '<br>' +
                                            '<small id="DecoupagePanel_sectorsPanelHeaderSc"></small>' +
                                        '</h5>' +
                                    '</div>' + 
                                    '<div class="card-body">' + 
                                        (C.PANELS.DECOUPAGE_PANEL.TWO_LEVELS ? '': this.sectorsTableHtml) +
                                    '</div>' + 
                                '</div>' + 
                            '</div>');
        
        
        this._$sectorFusionModal = $('<div id="DecoupagePanel_sectorFusionModal" class="modal fade" tabindex="-1" role="dialog" data-backdrop="static">' +
                                    '<div class="modal-dialog modal-sm" role="document">' +
                                        '<div class="modal-content">' +
                                            '<div class="modal-body">' +
                                                '<h5 style="margin-bottom:20px;">' + get("DecoupagePanel_SectorFusionWarning") + '</h5>' +
                                                '<p>Le <strong>secteur <span class="DecoupagePanel_newSectorFusionCode"></span></strong> existe déjà.</p><p>Voulez-vous fusionner les deux secteurs? (Le <strong>secteur <span class="DecoupagePanel_oldSectorFusionCode"></span></strong> sera supprimé et les points seront distribués dans le <strong>secteur <span class="DecoupagePanel_newSectorFusionCode"></span></strong>.)</p>' +
                                                '<div class="clearfix">' +
                                                    '<div class="btn-group pull-right">' +
                                                        '<button id="DecoupagePanel_sectorFusionAcceptBtn" type="button" class="btn btn-primary btn-sm" data-dismiss="modal" aria-label="Accept">Accepter</button>' +
                                                        '<button id="DecoupagePanel_sectorFusionCancelBtn" type="button" class="btn btn-default btn-sm" data-dismiss="modal" aria-label="Close">Annuler</button>' +
                                                    '</div>' +
                                                '</div>' +
                                            '</div>' +
                                        '</div>' +
                                    '</div>' +
                                '</div>');
        this._$footer = $('<div id="DecoupagePanel_footer">' +
                        '<div id="DecoupagePanel_toolbar" role="toolbar">' +
                            '<button id="DecoupagePanel_addSectorBtn" type="button" class="btn btn-sm btn-light" title="Ajouter : Ajouter un nouveau secteur"><i class="bi bi-plus-lg"></i>&nbspAjouter</button>' +
                            '<button id="DecoupagePanel_deleteSectorBtn" type="button" class="btn btn-sm btn-light" title="Supprimer : Supprimer le secteur sélectionné"><i class="bi bi-trash3"></i>&nbspSupprimer</button>' +
                        '</div>' +
                    '</div>');
        this._$addSectorBtn = this._$footer.find("#DecoupagePanel_addSectorBtn");
        this._$deleteSectorBtn = this._$footer.find("#DecoupagePanel_deleteSectorBtn");
        this._$statsPanel = this._$panelsContainer.find("#DecoupagePanel_statsPanel");
        this._transferTool = new TransferTool(this._$footer.find("#DecoupagePanel_toolbar"));
        $(this._$panelsContainer).on("click", ".DecoupagePanel_printBtn", this._onPrintBtnClicked.bind(this));
        $(this._$panelsContainer).mouseenter(function(evt) { $(evt.currentTarget).find(".DecoupagePanel_printBtn").removeClass("easeOut").addClass("easeIn"); }.bind(this));
        $(this._$panelsContainer).mouseleave(function(evt) { $(evt.currentTarget).find(".DecoupagePanel_printBtn").removeClass("easeIn").addClass("easeOut"); }.bind(this));
        
        this._$addSectorBtn.click(this._onAddSectorBtnClicked.bind(this));
        this._$deleteSectorBtn.click(this._onDeleteSectorBtnClicked.bind(this));
        
    };

    _onCartoVistaMapLoaded(evt) {
        this._map = window.cartovista.getMap(C.MAP.ID);
        this._map.addEventListener(this._map.EVENTS.ACTIVE_THEME_SET_CHANGED, this._onActiveThemeSetChanged, this);
        this._initialize();
    };

    _onServerDataInitialized(evt) {
        window.cartovista.addEventListener("TransferTool_TransferCompleted", this._onTransferCompleted, this);
        window.cartovista.addEventListener("SectorsDatastore_SectorDataDescriptionDirtyChanged", this._onSectorDataDescriptionDirtyChanged, this);
        window.cartovista.addEventListener("SectorsDatastore_SectorsDataAdded", this._onSectorsDataAdded, this);
        window.cartovista.addEventListener("SectorsDatastore_SectorsDataDeleted", this._onSectorsDataDeleted, this);
        if (C.PANELS.DECOUPAGE_PANEL.INCLUDE_STATISTICS) {
            this._initStatsPanel();
        }
    };

    _onPointsLayerCreated(evt) {
        this._pointsLayer = evt.source.layer;
        this._pointsLayerDataTable = this._pointsLayer.getDataTable(C.PANELS.DECOUPAGE_PANEL.POINTS.DATATABLE_ID);
        this._pointsLayerSumField = this._pointsLayerDataTable.getDataColumns(C.PANELS.DECOUPAGE_PANEL.POINTS.SUM_DATACOLUMN_ID)[0];
    };

    _onAuthSessionUserLoggedIn(evt) {
        this._toggleInputsDisabledProperty(C.APP_TOOLS.AUTH_SESSION.USER.EDITION_ALLOWED ? false : true);
    };

    _toggleInputsDisabledProperty(disabled) {
        if (disabled) {
            this._$addSectorSubmitBtn.prop("disabled", true);
            this._$addSectorBtn.prop("disabled", true);
            this._$deleteSectorBtn.prop("disabled", true);
        } else {
            this._$addSectorSubmitBtn.prop("disabled", "");
            this._$addSectorBtn.prop("disabled", "");
            this._$deleteSectorBtn.prop("disabled", "");
        }
    };

    _onReloadDataStarted(evt) {
        this._toggleInputsDisabledProperty(true);
    };

    _onReloadDataCompleted(evt) {
        this._toggleInputsDisabledProperty(C.APP_TOOLS.AUTH_SESSION.USER.EDITION_ALLOWED ? false : true);
    };

    _onActiveThemeSetChanged(evt) {
        if (this._map.activeThemeSet && this._map.activeThemeSet.id.startsWith("SCENARIO")) {
            this._$panelsContainer.find("#DecoupagePanel_sectorsPanelHeaderSc").html(this._map.activeThemeSet.title);
            this._createSectorsPanels();
            if (C.PANELS.DECOUPAGE_PANEL.INCLUDE_STATISTICS) {
                this._initStatsPanel();
            }
        } else {
            if (C.PANELS.DECOUPAGE_PANEL.TWO_LEVELS) {
                this._$panelsContainer.find("#DecoupagePanel_sectorsPanelGroup").empty()
            } else {
                this._$panelsContainer.find("#DecoupagePanel_sectorsTableBody").empty();
            }
            if (C.PANELS.DECOUPAGE_PANEL.INCLUDE_STATISTICS) {
                this._$statsPanel.find("td").empty();
            }
        }
    };

    _onAddSectorBtnClicked(evt) {
        this._$addSectorCodeInput.val("");
        if (C.PANELS.DECOUPAGE_PANEL.TWO_LEVELS) {
            this._addSectorGroupDropDown;
            this._$addSectorGroupDropDown.kendoDropDownList({
                "dataSource": {
                    "data": window.sectorsDataStore.getSectorsDataGroups(this._map._scenarioId)
                },
                "dataTextField": "name",
                "dataValueField": "group",
                "animation": false,
                "dataBound": $.proxy(function(evt) {
                    this._addSectorGroupDropDown = evt.sender;
                }, this)
            });
        }
        this._$addSectorModal.show();
        $("#DecoupagePanel_AddSectorModalWarning").addClass("show");
    };

    _onDeleteSectorBtnClicked(evt) {
        var sectorData = window.sectorsDataStore.getSelectedSector(this._map._scenarioId);
        if (typeof sectorData === "undefined") {
            show("DecoupagePanel_DeleteSectorError_1", {"title" : C.LOCALES.SECTORS.SECTOR.NAMES.SHORT_SINGLE});
        } else if (sectorData.sum > 0) {
            show("DecoupagePanel_DeleteSectorError_2", {"title" : C.LOCALES.SECTORS.SECTOR.NAMES.SHORT_SINGLE, "point": C.LOCALES.POINTS.NAMES.SHORT_SINGLE});
        } else {
            window.sectorsDataStore.deleteSectorData(sectorData);
        }
    };

    _onAddSectorSubmitBtnClicked(evt) {
        var sectorCode = this._$addSectorCodeInput.val();
        var sectorGroup = C.PANELS.DECOUPAGE_PANEL.TWO_LEVELS ? this._addSectorGroupDropDown.value() : sectorCode;
        if (this._validateAddSectorDataInputs(sectorGroup, sectorCode)) {
            var addedSectorData = window.sectorsDataStore.addSectorData(this._map._scenarioId, sectorGroup, sectorCode);
            this._$addSectorModal.hide();
        }
    };

    _onSectorsDataAdded() {
        this._createSectorsPanels();
        if (C.PANELS.DECOUPAGE_PANEL.INCLUDE_STATISTICS) {
            this._initStatsPanel();
        }
    };

    _onSectorsDataDeleted() {
        this._createSectorsPanels();
        if (C.PANELS.DECOUPAGE_PANEL.INCLUDE_STATISTICS) {
            this._initStatsPanel();
        }
    };

    _initStatsPanel() {
        if(window.statistics){
            this._$statsPanel.find("#DecoupagePanel_statsPanel_nbrTotal").html(window.statistics.sumTotal.toLocaleString("fr-CA"));
            this._$statsPanel.find("#DecoupagePanel_statsPanel_sectorsCount").html(window.statistics.sectorsCount);
            this._$statsPanel.find("#DecoupagePanel_statsPanel_nbrMean").html(window.statistics.nbr_mean.toLocaleString("fr-CA"));
            this._$statsPanel.find("#DecoupagePanel_statsPanel_nbrMin").html(window.statistics.nbr_min.toLocaleString("fr-CA"));
            this._$statsPanel.find("#DecoupagePanel_statsPanel_nbrMax").html(window.statistics.nbr_max.toLocaleString("fr-CA"));    
        }
    };

    _initialize() {
        $("#DecoupagePanel_btn").html('<span class="cv-icon"><i class="bi bi-card-list"></i></span>');
        this._decoupagePanelContainer = $("#DecoupagePanel");
        this._decoupagePanelContainer.html([this._$panelsContainer, this._$footer]);
        $("body").append([$('<div class="modal fade" id="DecoupagePanel_addSectorModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">' +
                                '<div class="modal-dialog modal-sm">' +
                                    '<div class="modal-content">' +
                                        '<div class="modal-header">' +
                                            '<h1 class="modal-title fs-5" id="staticBackdropLabel">Ajout d\'un ' + C.LOCALES.SECTORS.SECTOR.NAMES.SHORT_SINGLE + '</h1>' +
                                            '<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>' +
                                        ' </div>' +
                                        '<div class="modal-body">' +
                                            '<h5 style="margin-bottom:20px;">' + get("DecoupagePanel_AddSectorModalWarning") + '</h5>' +
                                            (C.PANELS.DECOUPAGE_PANEL.TWO_LEVELS ?
                                                '<div class="mb-3">' +
                                                    '<label for="DecoupagePanel_addSectorGroupDropDown" class="form-label">Veuillez choisir un code de ' + C.LOCALES.SECTORS.GROUP.NAMES.SHORT_SINGLE + ':</label>' +
                                                    '<span id="DecoupagePanel_addSectorGroupDropDown" class="form-control"></span>' +
                                                '</div>' : "") +
                                            '<div class="mb-3">' +
                                                '<label for="DecoupagePanel_addSectorCodeInput" class="form-label">Veuillez entrer un code de ' + C.LOCALES.SECTORS.SECTOR.NAMES.SHORT_SINGLE + ':</label>' +
                                                '<input id="DecoupagePanel_addSectorCodeInput" class="form-control" type="text" minlength="1" maxlength="2" size="25"></input>' +                                                
                                            '</div>' +
                                        '</div>' +
                                        '<div class="modal-footer">' +
                                            '<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Annuler</button>' +
                                            '<button id="DecoupagePanel_addSectorSubmitBtn" type="button" class="btn btn-primary" data-bs-dismiss="modal">Ajouter</button>' +
                                        '</div>' +
                                    '</div>' +
                                '</div>' +
                            '</div>'), this._$sectorFusionModal]);
        this._$addSectorModal = new Modal("#DecoupagePanel_addSectorModal");
        this._$addSectorSubmitBtn = $("#DecoupagePanel_addSectorModal").find("#DecoupagePanel_addSectorSubmitBtn");
        this._$addSectorGroupDropDown = $("#DecoupagePanel_addSectorModal").find("#DecoupagePanel_addSectorGroupDropDown");
        this._$addSectorCodeInput = $("#DecoupagePanel_addSectorModal").find("#DecoupagePanel_addSectorCodeInput");
        this._$addSectorSubmitBtn.click(this._onAddSectorSubmitBtnClicked.bind(this));
        if (C.PANELS.DECOUPAGE_PANEL.INCLUDE_STATISTICS) {
            window.statistics = new Statistics();
        }
        this._toggleInputsDisabledProperty(C.APP_TOOLS.AUTH_SESSION.USER.EDITION_ALLOWED ? false : true);
    };

    _createSectorsPanels() {
        if (C.PANELS.DECOUPAGE_PANEL.TWO_LEVELS) {
            var sectorsDataGroups = window.sectorsDataStore.getSectorsDataGroups(this._map._scenarioId);
            this._$panelsContainer.find(".card-body").html(_.map(sectorsDataGroups, function(sectorsDataGroup) {
                var $groupAccPanel = this._createGroupAccPanels(sectorsDataGroup);
                $groupAccPanel.find("#DecoupagePanel_sectorsTableBody").html(_.map(sectorsDataGroup.sectorsData, this._createTableRow.bind(this)));
                return $groupAccPanel;
            }.bind(this)));
        } else {
            var sectorsData = window.sectorsDataStore.getSectorsData(this._map._scenarioId);
            this._$panelsContainer.find("#DecoupagePanel_sectorsTableBody").html(_.map(sectorsData, this._createTableRow.bind(this)));
        }
    };

    _createGroupAccPanels(sectorDataGroup) {
        var $groupAccPanel = $('<div class="card">' + 
                            '<div class="card-header">' + 
                                '<div class="row" style="margin:0;">' +
                                    '<div class="col-6" style="padding:0;">' +
                                        '<h5>' +
                                            '<strong><a role="button" data-bs-toggle="collapse" href="#DecoupagePanel_collapseGroup_' + sectorDataGroup.group + '" aria-expanded="false" aria-controls="DecoupagePanel_collapseGroup_' + sectorDataGroup.group + '">' + C.LOCALES.SECTORS.GROUP.NAMES.SHORT_SINGLE + '&nbsp;' + sectorDataGroup.group + '</a></strong>' +
                                        '</h5>' +
                                    '</div>' + 
                                    '<div class="col-6 text-end" style="padding:0;">' +
                                        '<small>' + sectorDataGroup.sum.toLocaleString("fr-CA") + '&nbsp;' + (sectorDataGroup.sum > 1 ? C.LOCALES.POINTS.NAMES.LONG_PLURAL : C.LOCALES.POINTS.NAMES.LONG_SINGLE) +
                                        '<br>' +
                                        sectorDataGroup.sectorsData.length + '&nbsp;' + (sectorDataGroup.sectorsData.length > 1 ? C.LOCALES.SECTORS.SECTOR.NAMES.LONG_PLURAL : C.LOCALES.SECTORS.SECTOR.NAMES.LONG_SINGLE) +
                                        '</small>' +
                                    '</div>' + 
                                '</div>' + 
                            '</div>' + 
                            '<div class="collapse" id="DecoupagePanel_collapseGroup_' + sectorDataGroup.group + '">' +
                                '<div class="card-body">' + 
                                this.sectorsTableHtml +
                                '</div>' + 
                            '</div>' + 
                        '</div>');

        //too laggy
        /*$groupAccPanel.find("#DecoupagePanel_headingGroup_" + sectorDataGroup.group).mouseenter($.proxy(function() {
            this._pointsLayer.rolloverFeatures = sectorDataGroup.features;
        }, this));

        $groupAccPanel.find("#DecoupagePanel_headingGroup_" + sectorDataGroup.group).mouseleave($.proxy(function() {
            this._pointsLayer.rolloverFeatures = [];
        }, this));*/

        $groupAccPanel.find("#DecoupagePanel_collapseGroup_" + sectorDataGroup.group)[0].addEventListener('show.bs.collapse', event => {
            sectorDataGroup.collapsed = false;
        });

        $groupAccPanel.find("#DecoupagePanel_collapseGroup_" + sectorDataGroup.group)[0].addEventListener('hide.bs.collapse', event => {
            sectorDataGroup.collapsed = true;
        });

        return $groupAccPanel;
    };

    _generateStyleIconCanvas(color) {
        var layerStyleConfig = _.cloneDeep(C.LAYERS[C.PANELS.DECOUPAGE_PANEL.POINTS.LAYER_ID].STYLES[0]);
        layerStyleConfig.SYMBOLIZERS[0].COLOR = color;
        var canvas = document.createElement("canvas");
        new Promise(function(resolve, reject) {
            var font = FontLibrary.getFont(layerStyleConfig.SYMBOLIZERS[0].FONT_NAME);
            if (!font || !font.ready) {
                FontLibrary.addOneTimeEventListener(FontLibrary.EVENTS.FONT_READY + "_" + layerStyleConfig.SYMBOLIZERS[0].FONT_NAME, resolve);
            } else { resolve();}
        }).then(function() {
            drawStyleIconCanvas(canvas, layerStyleConfig);
        }.bind(this));
        return canvas;
    };

    _createTableRow(sectorData) {
        var $rowHtml = $('<tr sector_id="' + sectorData.id + '">' +
                            (C.APP_TOOLS.AUTH_SESSION.USER.EDITION_ALLOWED ?
                                '<td class="text-center">' +
                                    '<input class="DecoupagePanel_selectSectorInput" name="DecoupagePanel_selectSectorInput" type="radio" ' + (sectorData.selected ? 'checked="checked"' : "") + '" title="Sélectionner le secteur">' +
                                '</td>' : '<td></td>') +
                            '<td class="text-center">' +
                                '<a class="DecoupagePanel_colorPopover" href="javascript:void(0)" data-bs-toggle="popover"><span class="DecoupagePanel_symbolCanvas" title="Changer la couleur"></span></a>' +
                            '</td>' +
                            '<td class="text-center">' +
                                '<input class="DecoupagePanel_sectorCodeInput" ' + (C.APP_TOOLS.AUTH_SESSION.USER.EDITION_ALLOWED && sectorData.code != "EXT" ? "" : 'disabled="true"') + ' type="text" value="' + sectorData.code + '" minlength="1" maxlength="2" size="3" title="Modifier le code du secteur">' +
                            '</td>' +
                            '<td class="text-center">' + sectorData.sum.toLocaleString("fr-CA") + '</td>' +
                            (C.PANELS.DECOUPAGE_PANEL.INCLUDE_STATISTICS ? this._getPercentageColumn(sectorData) : '')  +
                            '<td class="text-center ' + (sectorData.descriptionDirty ? 'bg-warning' : '') + '">' +
                                '<a class="DecoupagePanel_descriptionBtn" href="javascript:void(0)" title="Afficher la description">' +
                                    '<i class="bi bi-journals ' + (sectorData.description ? 'hasDescription' : '') + '"></i>' +
                                '</a>' +
                            '</td>' +
                        '</tr>');

        var styleIconCanvas = this._generateStyleIconCanvas(sectorData.color);
        $rowHtml.find(".DecoupagePanel_symbolCanvas").html(styleIconCanvas);

        $rowHtml.find(".DecoupagePanel_selectSectorInput").change(function() {
            sectorData.selected = true;
        });

        $rowHtml.find(".DecoupagePanel_colorPopover").mouseenter($.proxy(function() {
            this._pointsLayer.rolloverFeatures = sectorData.features;
        }, this));

        $rowHtml.find(".DecoupagePanel_colorPopover").mouseleave($.proxy(function() {
            this._pointsLayer.rolloverFeatures = [];
        }, this));

        if (C.APP_TOOLS.AUTH_SESSION.USER.EDITION_ALLOWED) {
            _.forEach($rowHtml.find(".DecoupagePanel_colorPopover"), function(popover){
                new Popover(popover, {
                    "template": '<div class="DecoupagePanel_colorPickerPopover popover" role="popover"><div class="popover-arrow"></div><div class="popover-body"></div></div>',
                    "content": '<div class="DecoupagePanel_colorPickerWidget"></div>',
                    "container": "body",
                    "placement": "top",
                    "html": true,
                    "trigger":"manual"
                });
            });
            $rowHtml.find(".DecoupagePanel_colorPopover").click(function(evt) {
                Popover.getInstance(evt.currentTarget).toggle();
                $("body").on("mouseup.popover", function(e) {
                    if (!$(e.target).parents(".DecoupagePanel_colorPickerPopover").length) {
                        Popover.getInstance(evt.currentTarget).hide();
                        $("body").off("mouseup.popover");
                    }
                });
            });
            _.forEach($rowHtml.find(".DecoupagePanel_colorPopover"), function(popover){
                popover.addEventListener("shown.bs.popover", function() {
                    $(".DecoupagePanel_colorPickerWidget").kendoFlatColorPicker({
                        "value": sectorData.color,
                        "autoupdate": true,
                        "change": _.debounce(function(obj) {
                            var styleIconCanvas = this._generateStyleIconCanvas(ParserUtil.parseColor(obj.value).rgba);
                            $rowHtml.find(".DecoupagePanel_symbolCanvas").html(styleIconCanvas);
                        }.bind(this), 100)
                    });
                }.bind(this));
                popover.addEventListener("hide.bs.popover", function() {
                    var newRGBA = ParserUtil.parseColor($(".DecoupagePanel_colorPickerWidget").data("kendoFlatColorPicker").value());
                    this._changeSecteurColor(sectorData, newRGBA);
                }.bind(this));
              }.bind(this));
        }

        $rowHtml.find(".DecoupagePanel_sectorCodeInput").change($.proxy(function(evt) {
            this._onCodeSecteurChange(sectorData, evt.target.value);
        }, this));

        $rowHtml.find(".DecoupagePanel_descriptionBtn").click(function() {
            window.cartovista.dispatchEvent(new DBxEvent("DecoupagePanel_DescriptionBtnClicked", sectorData));
        });

        return $rowHtml;
    };

    _getPercentageColumn(sectorData) {
        var percentage = _.round(((sectorData.sum - window.statistics.nbr_mean) / window.statistics.nbr_mean * 100), 2);
        if (percentage > 0 && percentage <= 25) {
            return '<td class="text-center text-success-emphasis table-success">+' + percentage.toLocaleString("fr-CA") + '</td>';
        } else if (percentage > 0 && percentage >= 25) {
            return '<td class="text-center text-danger-emphasis table-danger">+' + percentage.toLocaleString("fr-CA") + '</td>';
        } else if (percentage < 0 && percentage >= -25) {
            return '<td class="text-center text-success-emphasis table-success">' + percentage.toLocaleString("fr-CA") + '</td>';
        } else {
            return '<td class="text-center text-danger-emphasis table-danger">' + percentage.toLocaleString("fr-CA") + '</td>';
        }
    };

    _onSectorDataDescriptionDirtyChanged(evt) {
        this._replaceTableRow(evt.source);
    };

    _replaceTableRow(sectorData) {
        this._$panelsContainer.find("#DecoupagePanel_sectorsTableBody tr[sector_id=" + sectorData.id + "]").replaceWith(this._createTableRow(sectorData));
    };

    _validateAddSectorDataInputs(sectorGroup, sectorCode) {
        if (!sectorCode.length || sectorCode.length > 2 || /[^a-zA-Z0-9]/.test(sectorCode)) {
            show("DecoupagePanel_AddSectorError_1", {"title": C.LOCALES.SECTORS.SECTOR.NAMES.SHORT_SINGLE});
            return false;
        } else if (!sectorGroup.length || sectorGroup.length > 2 || /[^a-zA-Z0-9]/.test(sectorGroup)) {
            show("DecoupagePanel_AddSectorError_2");
            return false;
        } else if (window.sectorsDataStore.getSectorsData(this._map._scenarioId, sectorGroup, sectorCode)) {
            show("DecoupagePanel_AddSectorError_3", {"title": C.LOCALES.SECTORS.SECTOR.NAMES.SHORT_SINGLE, "sectorCode" : sectorCode, "sectorGroup": sectorGroup, "scenario": this._map._scenario});
            return false;
        } else {
            return true;
        }
    };

    _onCodeSecteurChange(sectorData, newSectorCode) {
        var sectorGroup = C.PANELS.DECOUPAGE_PANEL.TWO_LEVELS ? sectorData.group : newSectorCode;
        if (!newSectorCode.length || newSectorCode.length > 2 || /[^a-zA-Z0-9]/.test(newSectorCode)) {
            show("DecoupagePanel_CodeSectorChangeError", {"title": C.LOCALES.SECTORS.SECTOR.NAMES.SHORT_SINGLE});
            this._replaceTableRow(sectorData);
        } else {
            if (typeof window.sectorsDataStore.getSectorsData(sectorData.scenario, sectorGroup, newSectorCode) != "undefined") {
                this._$sectorFusionModal.find(".DecoupagePanel_newSectorFusionCode").html(newSectorCode);
                this._$sectorFusionModal.find(".DecoupagePanel_oldSectorFusionCode").html(sectorData.code);
                this._$sectorFusionModal.find("#DecoupagePanel_sectorFusionAcceptBtn").off().one("click", function() {
                    sectorData.code = newSectorCode;
                });
                this._$sectorFusionModal.find("#DecoupagePanel_sectorFusionCancelBtn").off().one("click", $.proxy(function() {
                    this._replaceTableRow(sectorData);
                }, this));
                this._$sectorFusionModal.modal("show");
            } else {
                sectorData.code = newSectorCode;
            }
        }
    };

    _changeSecteurColor(sectorData, newRGBA) {
        if (sectorData.color !== newRGBA.rgba) {
            sectorData.color = newRGBA.rgba;
            this._applyThemeChanges(sectorData);
        }
    };

    _applyThemeChanges(sectorData) {
        console.time("DecoupagePanel._applyThemeChanges");
        this._map.activeThemeSet._themes[0]._colorTheme.applyToFeatures(this._pointsLayer, sectorData.features, false);
        this._createSectorsPanels();
        console.timeEnd("DecoupagePanel._applyThemeChanges");
    };

    _onTransferCompleted(evt) {
        console.time("DecoupagePanel._onTransferCompleted");
        var featuresIds = evt.source;
        this._pointsLayer.getFeatures(featuresIds, function(result) {
            this._map.activeThemeSet._themes[0]._colorTheme.applyToFeatures(this._pointsLayer, result.features, false);
            this._createSectorsPanels();
            console.timeEnd("DecoupagePanel._onTransferCompleted");
        }, this);
    };

    _onPrintBtnClicked(evt) {
        var $printedPanel = $(evt.target).closest("#DecoupagePanel_container"),
            panelId = $printedPanel.attr("data-panel"),
            elemsToPrint = $printedPanel.find(".DecoupagePanel_printable:visible").get(),
            filename = this._map.activeThemeSet.title,
            printOption = {"landscape": false, "scale": 0.5};
        exportToPDF(elemsToPrint, filename, printOption);
    };
}
